<template>
  <Modal
    :id="'cmp-distribution-reports-open_order_report_modal'"
    @cancelled="onCancel"
  >
    <template slot="header">{{ $t('open_order_report') }}</template>
    <template slot="body">
      <div class="form-group">
        <Dropdown
          :options="accounts_TV"
          class="m2"
          :placeholder="$t('account')"
          :selected="
            accounts_TV.find((x) => x.value == filterSelectionData.account_id)
          "
          v-on:selectedChange="(e) => onDropdownChange('account_id', e)"
          box
          deslect
          :listHeight="350"
          showValidationIcons
          required
          immediateValidation
          @validated="(e) => onValidation('account_id', e)"
        ></Dropdown>
        <Dropdown
          :options="labels_TV"
          class="m2"
          :placeholder="$t('label')"
          :selected="
            labels_TV.find((x) => x.value == filterSelectionData.label_id)
          "
          v-on:selectedChange="(e) => onDropdownChange('label_id', e)"
          box
          deslect
          :listHeight="350"
          showValidationIcons
          required
          immediateValidation
          @validated="(e) => onValidation('label_id', e)"
        ></Dropdown>

        <TextField
          :id="'start_date'"
          class="m1"
          v-bind="textFieldConfig"
          type="date"
          style="padding-bottom: 30px"
          :value="filterSelectionData.start_date"
          showValidationIcons
          required
          immediateValidation
          @validated="onValidation"
          :placeholder="$t('start_date')"
          @valuechanged="onTextFieldValueChange"
        />
        <div class="checkbox-container">
          <div class="select-checkbox">
            <div class="dt-checkbox v2 s1">
              <input
                type="checkbox"
                :name="'backorder'"
                :id="'backorder'"
                @change="checkboxChange('backorder')"
                :checked="filterSelectionData.backorder"
              />
              <div class="checkmark"></div>
            </div>
          </div>
          <div class="select-text">{{ $t('back_orders') }}</div>
        </div>
        <div class="checkbox-container">
          <div class="select-checkbox">
            <div class="dt-checkbox v2 s1">
              <input
                type="checkbox"
                :name="'open_order'"
                :id="'open_order'"
                @change="checkboxChange('open_order')"
                :checked="filterSelectionData.open_order"
              />
              <div class="checkmark"></div>
            </div>
          </div>
          <div class="select-text">{{$t('open_orders')}}</div>
        </div>
        <div class="checkbox-container">
          <div class="select-checkbox">
            <div class="dt-checkbox v2 s1">
              <input
                type="checkbox"
                :name="'manufacturing'"
                :id="'manufacturing'"
                @change="checkboxChange('manufacturing')"
                :checked="filterSelectionData.manufacturing"
              />
              <div class="checkmark"></div>
            </div>
          </div>
          <div class="select-text">{{$t('open_manufacturing')}}</div>
        </div>
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $dft.snakeCaseToWords("cancel") }}
      </button>
      <button
        :class="{ disabled: !isFormValid }"
        class="dt-button v1 s6"
        @click.stop="onSave"
      >
        {{ $dft.snakeCaseToWords("Show Account") }}
      </button>
      <button
        :class="{ disabled: !isFormValid }"
        class="dt-button v1 s6"
        @click.stop="onSave2"
      >
        {{ $dft.snakeCaseToWords("Summarized") }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "../../../../dt-plugins/modal/modal";
import { ReportService } from "../../services/reports.service";
import InputField from "../../../../plugins/text-field/input-field";
import { createTV } from "../../../../models/text-value.model";
import { EventHooks } from "../../../../plugins/text-field";
import FileDownload from "js-file-download";
import {
  ConfirmationService,
  createConfirmResult,
} from "@/dt-plugins/confirmation/confirmation.service";
export default {
  components: {
    InputField,
    Modal,
  },
  props: ["filteredData"],
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        immediateValidation: true,
        validationEvent: EventHooks.OnKeyup,
        isModel: true,
      },

      validationResult: {},
      filterSelectionData: {
        label_id: null,
        account_id: null,
        start_date: null,
        backorder: null,
        open_order: null,
        manufacturing: null,
      },

      openOrderReportModel: {},
    };
  },
  mounted: function () {
    this.getOpenOrderReportModalData();
  },
  computed: {
    labels_TV: function () {
      return createTV(
        this.openOrderReportModel.labels || [],
        "label_name",
        "label_id"
      );
    },
    accounts_TV: function () {
      return createTV(
        this.openOrderReportModel.accounts || [],
        "account_name",
        "account_id"
      );
    },
    isFormValid: function () {
      return Object.values(this.validationResult).every((e) => e.valid);
    },
  },

  methods: {
    checkboxChange(action) {
      switch (action) {
        case "backorder":
          this.filterSelectionData.backorder =
            !this.filterSelectionData.backorder;
          break;
        case "open_order":
          this.filterSelectionData.open_order =
            !this.filterSelectionData.open_order;
          break;
        case "manufacturing":
          this.filterSelectionData.manufacturing =
            !this.filterSelectionData.manufacturing;
          break;
      }
    },
    getOpenOrderReportModalData: async function () {
      const result = await ReportService.getOpenOrderReportModalData();
      this.openOrderReportModel = {
        ...this.openOrderReportModel,
        ...result.data,
      };
    },
    onTextFieldValueChange: function (name, value) {
      this.filterSelectionData[name] = value;
    },
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },
    onSave2: async function () {
      ReportService.getOpenOrderSummarizedReportExportData({
        ...this.filterSelectionData,
      }).then(
        (res) => {
          if (res) {
            console.log({ fileURL: res.data });
            FileDownload(res.data, "summarized_open_orders.xlsx");
            this.onCancel();
          } else {
            const confirmationResult = ConfirmationService.createP({
              body:this.$t('open_order_report_empty_result'),
              width: 376,
              results: [
                createConfirmResult({
                  value: "ok",
                  text: "OK",
                  classes: ["v1 s7"],
                }),
              ],
            });
            
          }
        },
        (err) => {
          console.log("err");
        }
      );
    },
    onSave: async function () {
      const res = await ReportService.getOpenOrderAccountReportExportData({
        ...this.filterSelectionData,
        backorder: this.filterSelectionData.backorder ? 1 : 0,
        open_order: this.filterSelectionData.open_order ? 1 : 0,
        manufacturing: this.filterSelectionData.manufacturing ? 1 : 0,
      });
      console.log({ fileURL: res.data });
      FileDownload(res.data, "Account_open_orders.xlsx");
      this.onCancel();
    },
    onDropdownChange: function (name, value) {
      this.filterSelectionData[name] = value.value;
    },

    onCancel: function () {
      this.$emit("cancelled", true);
    },
  },
};
</script>

<style lang="scss">
.cmp-distribution-reports-open_order_report_modal {
  .dt-modal--body {
    margin-left: 0px;
    padding-right: 40px;
  }
  .dt-modal--options {
    button {
      &:first-child {
        margin-right: 40px;
      }
      &:last-child {
        margin-left: 0px 10px;
      }
    }
  }
  .checkbox-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    height: 30px;
    .select-checkbox {
      padding-right: 5px;
    }
  }
}
</style>
